/**
 *
 * Asynchronously loads the component for Planning
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Planning = lazyLoad(
  () => import('./index'),
  module => module.Planning,
);
